<template>
  <div class="blog">
    <breadcrumb v-bind:path2="path2" v-bind:path1="path1"></breadcrumb>
    <div v-if="this.isLoading" class="blog-container">
      <div class="page-width">
        <div class="loadmore disableBtn">
          <span>{{ $t('loading')}}</span>
          <i class="loading">
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
          </i>
        </div>
      </div>
    </div>
    <div v-if="!this.isLoading" class="blog-container">
      <div>
        <h3>{{this.blog.title}}</h3>
        <p>{{this.blog.post_date}}</p>
      </div>
      <div class="blog-content">
        <div class="blog-left">
          <img v-if="blog.image_file" :src="blog.image_file" alt="">
          <img v-else src="../../assets/img/coming.png" alt="">
        </div>
        <div class="blog-right">
          <!-- content -->
          <p v-if="this.blog.rich_text_description">
            <span v-html="this.blog.rich_text_description"></span> 
          </p>
          <p>{{this.blog.post_date}}</p>
          <!-- comment -->
          <!-- <commentForm
            v-bind:id="blog.blog_id"
            location="blog"
          /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapState, mapMutations } from 'vuex';
import breadcrumb from '../../components/breadcrumb';
import commentForm from '../../components/commentForm';

export default {
  name: "blogDetail",
  components: {
    breadcrumb,
    commentForm,
  },
  data() {
    return {
      path1: {
        name: this.$t('blog'),
        path: '/blogs',
      },
      path2: '', // this will show blog title
      blog: {},
      isLoading: false,
    }
  },
  methods: {
    ...mapActions('blog',['fetchBlogDetail']),
    getBlogDetail(id) {
      this.isLoading = true;
      this.fetchBlogDetail(id)
      .then(res => {
        this.isLoading = false;
        this.blog = res.data;
        this.path2 = this.blog.title;
        this.blog.post_date = moment(String(res.data.post_date)).format('LL');
      })
      .catch(err => {
        this.isLoading = false;
        console.log('err', err)
      })
    },
  },
  mounted() {
    const url = this.$route.fullPath;
    const lastURLSegment = url.substr(url.lastIndexOf('/') + 1);
    const blogId = this.selectBlogId || lastURLSegment;
    this.getBlogDetail(blogId);
  },
  computed: mapState({
    selectBlogId: state => state.blog.selectBlogId,
  }),
  watch: {
    selectBlogId: function(newVal, oldVal) {
      this.getBlogDetail(newVal);
    },
  }
}
</script>

<style scoped lang="less">
@import "../../assets/css/public.less";
@import "../../assets/css/blog.less";
</style>



// WEBPACK FOOTER //
// src/view/blog/blogDetail.vue